<div class="dx-fieldset">
  <div class="dx-field">
    <div class="dx-field-label">{{ 'Gruppe auswählen' | translate }}</div>
    <div class="dx-field-value">
      <dx-select-box
        placeholder="Gruppe"
        [items]="resultExcelFieldGroups"
        (onValueChanged)="onGroupValueChanged($event)"
      />
    </div>
  </div>
  <div class="dx-field">
    <div class="dx-field-label"> {{ 'Feld auswählen' | translate }}</div>
    <div class="dx-field-value">
      <dx-select-box
        displayExpr="name"
        valueExpr="name"
        [items]="relevantResultExcelFields"
        [(value)]="field"
        (onSelectionChanged)="fieldChange.emit(field)"
      />
    </div>
  </div>
</div>
